import AutocompleteComponent from 'components/design-system/Autocomplete/Autocomplete';
import { AutoCompleteAsyncController } from 'components/design-system/AutoCompleteAsync/AutoCompleteAsyncController';
import InputComponent from 'components/design-system/input/Input';
import LabelComponent from 'components/design-system/Label/Label';
import { ObtieneRoles } from 'hooks/useServices';
import { obtenerTodasLasEmpresas } from 'views/CargaMasiva/hooks/useServices';
import { SeleccionarSucursal } from './SeleccionarSucursal';

export const SolicitudUnicaForm = ({
  isSubmitting,
  setFieldValue,
  values,
  setFieldTouched,
  errors,
  touched,
  handleBlur,
  handleChange
}) => {
  const { roles, isLoadingRoles } = ObtieneRoles();
  const { rol, negocio } = values;

  return (
    <div className="grid grid-cols-12 gap-5">
      <div className="col-span-12 md:col-span-6 xl:col-span-4">
        <AutocompleteComponent
          className="mb-3"
          accesor="nombreRol"
          name="rol"
          clearOnEscape={true}
          openOnFocus={false}
          isLoading={isLoadingRoles}
          options={roles || []}
          placeholder={'Buscar rol'}
          disabled={isLoadingRoles || isSubmitting}
          getOptionLabel={option => option.nombreRol || ''}
          noOptionsText={'Sin opciones'}
          onChange={(ev, selected, reason) => {
            let data = { name: 'rol', value: selected };
            if (reason === 'clear') {
              data.value = null;
            }
            setFieldValue('rol', data.value);
            setFieldValue('negocio', null); // Limpiar negocio al cambiar rol
            setFieldTouched('negocio', false);
          }}
        >
          <InputComponent
            className="h-9"
            fullWidth
            placeholder="Buscar..."
            label={<LabelComponent>Rol</LabelComponent>}
          />
        </AutocompleteComponent>
      </div>
      <div className="col-span-12 md:col-span-6 xl:col-span-4">
        <AutoCompleteAsyncController
          name="negocio"
          accesor="label"
          required
          fullWidth
          value={negocio}
          disabled={isSubmitting}
          noOptionsText={'Sin opciones'}
          label={<LabelComponent>Buscar negocio</LabelComponent>}
          setFieldValue={data => setFieldValue('negocio', data)}
          setFieldTouched={() => setFieldTouched('negocio')}
          isSubmitting={isSubmitting}
          preload={true}
          rol={rol}
          fetchCall={controllerValues => {
            obtenerTodasLasEmpresas({
              setLoadingEmpresas: controllerValues.setIsLoading,
              setEmpresas: controllerValues.setData,
              paginationEmpresas: controllerValues.paginationEmpresas,
              nombreEmpresa: controllerValues.inputValue,
              setRowCountEmpresas: controllerValues.setRowCountEmpresas,
              rol: controllerValues.rol
            });
          }}
        />
      </div>
      <div className="col-span-4"></div>

      {negocio && (
        <SeleccionarSucursal
          values={values}
          errors={errors}
          touched={touched}
          handleChange={handleChange}
          handleBlur={handleBlur}
          setFieldValue={setFieldValue}
          setFieldTouched={setFieldTouched}
          disabled={isSubmitting}
        />
      )}
    </div>
  );
};
